import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LegalPage } from '@/features/legal/LegalPage';

/**
 * `/delete-account` — the PUBLIC account-deletion page (slice 81).
 *
 * Google Play requires a world-readable page describing how a user deletes
 * their account. English copy matches the deletion wording in
 * `docs/play/PLAY_LISTING.md` §7; the Somali is Mahad's verbatim text from
 * `docs/play/delete-account-so.txt` — the BODY is byte-exact, never edited; the
 * title is its first sentence ("Tirtir akoonkaaga Raad"), Mahad's own words. The WhatsApp
 * and email buttons live in the shared `LegalPage` chrome.
 */
export function DeleteAccount() {
  const { t } = useTranslation();

  return (
    <LegalPage title={t('legal.deleteAccount.title')}>
      <p className="mt-6 text-[15px] leading-relaxed text-raad-text">
        {t('legal.deleteAccount.body')}
      </p>

      <p className="mt-6 text-[15px] leading-relaxed">
        <Link
          to="/privacy"
          className="font-semibold text-raad-primary underline underline-offset-2"
        >
          {t('legal.deleteAccount.privacyLink')}
        </Link>
      </p>
    </LegalPage>
  );
}
